<template>
  <div class="navigation tw-bg-white">
    <v-container>
      <div class="wrapper">
        <div class="menu-wrapper">
          <router-link v-bind:to="'/'">
            <img src="/images/logo_phasi_charoen.svg" alt="ภาษีเจริญ" class="logo"/>
          </router-link>
          <div class="menu">
            <router-link v-bind:to="'/'">หน้าแรก</router-link>
            <a href="/#feature">ฟีเจอร์</a>
            <router-link v-bind:to="'/package'">แพ็คเกจ</router-link>
            <a href="/#contact">ติดต่อเรา</a>
          </div>
        </div>
        <div class="user-menu">
          <router-link v-bind:to="'/login'" class="login" v-if="!isLogin">
            เข้าสู่ระบบ
          </router-link>
          <router-link v-bind:to="'/register'" class="register" v-if="!isLogin">
            สมัครใช้งาน
          </router-link>

          <div class="login" v-if="isLogin" style="display: flex; margin-top: -10px">
            <router-link v-bind:to="'/companies-list'" class="login">
              จัดการเอกสาร
            </router-link>
            <span style="margin-top: -10px;">
              <app-bar-profile></app-bar-profile>
            </span>
          </div>
          <!--          <router-link v-on:click.native="logout" class="register" v-else to="">-->
<!--            ออกจากระบบ-->
<!--          </router-link>-->
        </div>
        <div class="mobile-menu" @click="toggleMobileNavigation">
          <img src="/images/icons/icon_menu.svg" alt="menu" class="mobile-menu-icon">
        </div>
        <transition name="fade">
          <div class="mobile-navigation" v-if="this.openMobileNavigation">
            <img src="/images/logo_phasi_charoen.svg" alt="ภาษีเจริญ" class="logo"/>
            <div class="close" @click="toggleMobileNavigation">
              <v-icon large>mdi-close-circle-outline</v-icon>
            </div>
            <router-link v-bind:to="'/'">หน้าแรก</router-link>
            <a href="/#feature">ฟีเจอร์</a>
<!--            <router-link v-bind:to="'/#'">แพ็คเกจ</router-link>-->
            <a href="/#contact">ติดต่อเรา</a>
            <router-link v-bind:to="'/login'" class="login">
              เข้าสู่ระบบ
            </router-link>
            <router-link v-bind:to="'/register'" class="register">
              สมัครใช้งาน
            </router-link>
          </div>
        </transition>
      </div>
    </v-container>
  </div>
</template>

<script>
import firebase from "firebase/app"
import "firebase/auth"
import AppBarProfile from './app-bar-profile'

export default {
  name: 'AppBar',
  components: {
    AppBarProfile
  },
  methods: {
    toggleMobileNavigation: function () {
      this.openMobileNavigation = !this.openMobileNavigation
    },
    logout: function (){
      this.$store.dispatch('auth/logout')
    },
  },
  data: function () {
    return {
      openMobileNavigation: false,
      currentRouterName: this.$route.name,
      isLogin: false
    }
  },
  created() {
    if(firebase.auth().currentUser){
      this.isLogin  = true
    }else{
      this.isLogin = false
    }
  }
}
</script>

<style lang="scss">
.navigation {
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border-bottom-left-radius: 100px;

  .wrapper {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-top: 20px;
    padding-bottom: 20px;
    a {
      text-decoration: none;
    }

    .menu-wrapper {
      display: flex;

      .logo {
        width: 100px;
        margin-top: -10px;
      }

      .menu {
        margin: 15px 0 0 25px;

        .v-btn {
          background: #FFFFFF !important;
        }

        a {
          color: #191919;
          margin: 0 20px;
          text-decoration: none;
        }
      }
    }

    .user-menu {
      margin-top: 14px;

      a {
        padding: 10px 30px;
      }

      .login {
        color: #191919;
      }

      .register {
        width: 150px;
        height: 44px;
        border-radius: 10px;
        background-color: #6ec39b;
        color: #FFFFFF !important;
      }
    }

    .mobile-menu {
      display: none;
      width: 30px;
      height: 30px;
      margin-top: 25px;
      margin-right: 10px;
    }

    .mobile-navigation {
      position: fixed;
      top: 0;
      left: 0;
      bottom: -100px;
      right: 0;
      background: #FFFFFF;
      z-index: 1;
      overflow-y: scroll;
      text-align: center;
      padding-top: 150px;
      padding-bottom: 100px;

      .logo {
        position: fixed;
        left: 32px;
        top: 22px;
        width: 100px;
      }

      .close {
        width: 70px;
        height: 94px;
        background: #6ec39b;
        border-bottom-left-radius: 50px;
        position: fixed;
        top: 0;
        right: 0;
        font-size: 60px;

        i {
          color: #FFFFFF;
        }
      }

      a {
        display: block;
        font-size: 26px;
        color: #191919;
        line-height: 70px;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .wrapper {
      padding-top: 0;
      .menu, .user-menu {
        display: none;
      }

      .logo {
        position: relative;
        top: 10px;
        left: 20px;
      }

      .mobile-menu {
        display: block;
      }
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .4s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
}
</style>
